import React from 'react';
import './WhatsAppButton.css';

const WhatsAppButton: React.FC = () => {
  const phoneNumber = '255768249444'; // Without + sign
  const message = 'Hello! I would like to get more information about your services.';
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      aria-label="Chat on WhatsApp"
    >
      <div className="whatsapp-icon-wrapper">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="whatsapp-icon"
        >
          <path
            d="M12.032 21.965c-1.916 0-3.771-.542-5.36-1.562l-4.82 1.581 1.62-4.706A9.933 9.933 0 0 1 2.032 12c0-5.514 4.486-10 10-10s10 4.486 10 10-4.486 10-10 10z"
            fill="#25D366"
            stroke="white"
            strokeWidth="0.5"
          />
          <path
            d="M17.04 13.482c-.277-.139-1.64-.81-1.894-.902-.254-.092-.438-.139-.623.139-.185.277-.717.902-.879 1.087-.162.185-.324.208-.601.069-.277-.139-1.17-.432-2.229-1.377-.824-.736-1.38-1.645-1.542-1.923-.162-.277-.017-.427.122-.565.124-.124.277-.324.416-.486.139-.162.185-.277.277-.462.093-.185.046-.347-.023-.486-.07-.139-.623-1.503-.854-2.058-.225-.54-.454-.437-.623-.445-.162-.008-.347-.009-.532-.009-.185 0-.486.069-.74.347-.254.277-.972.95-.972 2.317s.994 2.688 1.133 2.873c.139.185 1.957 2.988 4.742 4.188.662.286 1.179.457 1.582.585.665.212 1.27.182 1.748.11.533-.08 1.64-.67 1.871-1.318.231-.648.231-1.203.162-1.319-.069-.116-.254-.185-.531-.324z"
            fill="white"
          />
        </svg>
      </div>
      <span className="whatsapp-tooltip">Chat with us on WhatsApp</span>
      <div className="whatsapp-pulse"></div>
    </a>
  );
};

export default WhatsAppButton;